import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { reasonListHeaders } from '../../constants';
import { getSelectionToClipboard } from '../../../Common/utils';

import useReasonList from './hooks';
import styles from './ReasonList.module.scss';

function ReasonList({ reasonReports, loading }) {
  const { handleColumnClick, sortByColumn, sortDirection } = useReasonList();

  return (
    <div className={styles.gridContainer} onMouseUp={getSelectionToClipboard} role="none">
      <DataGrid
        rows={reasonReports}
        headers={reasonListHeaders}
        fullWidth
        loading={loading}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
}

ReasonList.propTypes = {
  reasonReports: PropTypes.arrayOf(
    PropTypes.shape({
      reasonCode: PropTypes.string,
      description: PropTypes.string,
      noteRequired: PropTypes.bool,
      alertType: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};

ReasonList.defaultProps = {
  reasonReports: [],
  loading: false,
};

export default ReasonList;
